module.exports = __webpack_public_path__ + "img/1_de.503942a8.webp";